import { render } from "./update_phone.vue?vue&type=template&id=037f220c&scoped=true"
import script from "./update_phone.vue?vue&type=script&lang=js"
export * from "./update_phone.vue?vue&type=script&lang=js"

import "./update_phone.vue?vue&type=style&index=0&id=037f220c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037f220c"]])

export default __exports__